import { doc, updateDoc, setDoc, collection } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import { firestore } from "../../../firebase";

const db = firestore;

const FUNCTIONS_BASE = "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor";

/** "…Restaurant_Review-g123-d4567-Reviews-…" → "4567" (or null). */
export const tripadvisorIdFromLink = (link) => {
  const match = typeof link === "string" ? link.match(/-d(\d+)-/) : null;
  return match ? match[1] : null;
};

/** "https://www.yelp.com/biz/some-place-oslo?x=1" → "some-place-oslo" (or null). */
export const yelpIdFromLink = (link) => {
  const match = typeof link === "string" ? link.match(/yelp\.[a-z.]+\/biz\/([^/?#]+)/i) : null;
  return match ? match[1] : null;
};

/**
 * Fetch Tripadvisor rating + reviews for a location and store them — same
 * fields and tripAdvisorRatings subcollection as useLocationEditor.js's save.
 * Returns the rating (number) or null.
 */
export async function saveTripadvisorRating(locationId, tripadvisorLink) {
  const id = tripadvisorIdFromLink(tripadvisorLink);
  if (!id) return null;

  const res = await fetch(`${FUNCTIONS_BASE}/${id}`);
  const data = await res.json();
  if (!data?.businessDetailsData) {
    throw new Error(data?.error || "Tripadvisor lookup failed");
  }

  const docRef = doc(db, "lokasjoner", locationId);
  await updateDoc(docRef, {
    tripadvisorRating: parseFloat(data.businessDetailsData.rating),
    tripadvisorLastUpdate: new Date(),
    tripadvisorId: id,
    tripadvisorNumReviews: parseFloat(data.businessDetailsData.num_reviews),
    tripadvisorLink: tripadvisorLink,
    tripadvisorRatingImageLink: data.businessDetailsData.rating_image_url,
  });
  await setDoc(doc(collection(docRef, "tripAdvisorRatings"), uuidv4()), {
    reviews: data.reviewData.data,
    date: new Date(),
  });

  const rating = parseFloat(data.businessDetailsData.rating);
  return isNaN(rating) ? null : rating;
}

/**
 * Fetch Yelp rating + reviews for a location and store them — same fields
 * and yelpRatings subcollection as useLocationEditor.js's save.
 * Returns the rating (number) or null.
 */
export async function saveYelpRating(locationId, yelpLink) {
  const yelpId = yelpIdFromLink(yelpLink);
  if (!yelpId) return null;

  const res = await fetch(`${FUNCTIONS_BASE}/yelpDetails/${yelpId}`);
  const data = await res.json();
  if (!data?.businessDetailsData) {
    throw new Error(data?.error || "Yelp lookup failed");
  }

  const docRef = doc(db, "lokasjoner", locationId);
  await updateDoc(docRef, {
    yelpRating: parseFloat(data.businessDetailsData.rating),
    yelpLastUpdate: new Date(),
    yelpId: data.businessDetailsData.id,
    yelpLink: yelpLink,
    yelpNumReviews: data.businessDetailsData.review_count,
  });
  await setDoc(doc(collection(docRef, "yelpRatings"), uuidv4()), {
    reviews: data.reviewData?.reviews,
    date: new Date(),
  });

  const rating = parseFloat(data.businessDetailsData.rating);
  return isNaN(rating) ? null : rating;
}
